module.exports = __webpack_public_path__ + "static/media/clapper.a6e5a093.png";